import * as React from 'react';

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    role="img"
    {...props}
  >
    <path
      style={{
        fill: 'currentColor',
        strokeWidth: 7.552737,
        strokeLinecap: 'butt',
        strokeLinejoin: 'round',
        stroke: 'currentColor',
        strokeOpacity: 1,
        strokeMiterlimit: 4,
      }}
      d="M579.718 678.359h292.466V385.892H579.718Zm0 0"
      transform="matrix(.09333 0 0 .09333 -53.755 -35.665)"
    />
    <path
      style={{
        fillRule: 'nonzero',
        fill: 'currentColor',
        fillOpacity: 1,
        strokeWidth: 7.041174,
        strokeLinecap: 'butt',
        strokeLinejoin: 'round',
        stroke: 'currentColor',
        strokeOpacity: 1,
        strokeMiterlimit: 4,
      }}
      d="M588.465 669.612h274.972V394.64H588.465Zm0 0"
      transform="matrix(.09333 0 0 .09333 -53.755 -35.665)"
    />
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#red',
        fillOpacity: 1,
      }}
      d="m10.91 18.625 2.063.367-.106.903-2.015-.965Zm0 0"
    />
    <path
      style={{
        fillRule: 'nonzero',
        fill: '#fff',
        fillOpacity: 1,
        strokeWidth: 1.88531,
        strokeLinecap: 'butt',
        strokeLinejoin: 'miter',
        stroke: '#fff',
        strokeOpacity: 1,
        strokeMiterlimit: 4,
      }}
      d="M705.401 646.97c11.468 7.156 25.698 11.55 43.192 11.509 91.364.335 91.448-120.745 91.448-120.745v-.042l.042.084-.21-.168c7.116 1.214 8.539-8.328 9.292-11.97.712-3.64-.418-13.81-.502-18.75.293-6.612 3.767-22.307 3.725-28.669 0-5.524 2.092-18.54-12.807-14.397-.168-2.846-.21-16.448-.21-16.448s-.209-9.71-.836-19.754c-.419-6.822-2.47-21.722-7.576-37.25H720.51"
      transform="matrix(.09333 0 0 .09333 -53.755 -35.665)"
    />
    <path
      style={{
        fillRule: 'nonzero',
        fill: 'currentColor',
        fillOpacity: 1,
        strokeWidth: 4.247696,
        strokeLinecap: 'square',
        strokeLinejoin: 'round',
        stroke: '#fff',
        strokeOpacity: 1,
        strokeMiterlimit: 4,
      }}
      d="M583.526 613.655c24.233 24.065 81.78 52.818 118.318 38.17 1.8-.712 3.557-1.842 5.148-3.307 1.213-1.13 2.343-2.427 3.264-3.892 2.386-3.641 3.265-8.078 2.637-12.89 0 0 .167-3.098-3.474-15.612-.712-2.804 1.549-4.436 4.478-5.525 6.655-2.51 9.836-10.672-.083-15.318 0 0-21.01-8.789-35.575-18.122 0 0 27.162 9.082 44.364 9.082 2.134 0 7.742.754 8.956-5.943.502-3.516-2.679-9.835-2.679-14.9 0 0-.837-2.636 4.855-3.306.837-.083 33.734-3.348 10.003-41.141 0 0-11.802-18.75-12.974-59.389 0-10.296 1.214-40.597-9.626-71.191"
      transform="matrix(.09333 0 0 .09333 -53.755 -35.665)"
    />
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: 'currentColor',
        fillOpacity: 1,
      }}
      d="M17.91 9.54c-.297.065-.195-.185.004-.462.379-.527 2.031-1.836 2.906.11.13.28.153.425-.039.386-.336-.062-1.347-.37-2.87-.035"
    />
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#fff',
        fillOpacity: 1,
      }}
      d="M7.29 9.383c-.302.043-.18-.195.038-.457.422-.496 2.172-1.668 2.89.34.106.289.118.437-.07.386-.328-.093-1.312-.48-2.859-.27"
    />
    <path
      style={{
        fill: 'none',
        strokeWidth: 5.661679,
        strokeLinecap: 'butt',
        strokeLinejoin: 'round',
        stroke: '#fff',
        strokeOpacity: 1,
        strokeMiterlimit: 4,
      }}
      d="M583.233 615.622c20.592 23.102 83.287 52.692 119.699 37.793 1.297-.544 3.641-1.842 5.231-3.307a20.889 20.889 0 0 0 3.265-3.85"
      transform="matrix(.09333 0 0 .09333 -53.755 -35.665)"
    />
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: 'currentColor',
        fillOpacity: 1,
      }}
      d="M13.309.89c.011-.027-.079-.1-.07-.12.054 0 .105-.13.105-.13 1.16 3.415 1.078 7.13 1.297 8.981.273 2.106 1.222 4.11 1.254 4.172.054.598-2.407.773-2.407.773s-2.18-7.632-2.18-8.07c0-.39 1.672-4.754 2-5.605M12.258 19.402c-.227-.129-.106-.418.156-.351 1.274.36 2.844.582 3.79.582.124 0 1.944.082 3.722-.59.156-.063.242-.047.3.043.047.105.02.187-.085.27-.625.476-1.934 1.183-3.914 1.183-1.672 0-3.407-.832-3.97-1.137"
    />
  </svg>
);

export default SvgComponent;